// Shared constants for the Execora landing page

import flowersImg from "../assets/images/flowers.jpeg";
import mangoJuiceImg from "../assets/images/mango-juice.jpeg";
import electricalImg from "../assets/images/electricals.jpg";
import watchImg from "../assets/images/watch.jpeg";
import photocopyImg from "../assets/images/photocopy.jpeg";
import ironingImg from "../assets/images/ironing.jpeg";
import heroImg from "../assets/images/hero.jpeg";
import mapImg from "../assets/images/map.jpeg";

export const CONTACT = {
  whatsappNumber: "+91 8147672424",
  callNumber: "+918147672424",
  whatsappDisplay: "+91 81476-72424",
  callDisplay: "+91 81476-72424",
};

// Route every WhatsApp click through /wa.html so it always opens WhatsApp in the
// correct (English) locale — even when the click happens inside in-app browsers
// like Instagram or LinkedIn (which otherwise default to pt-BR and mangle
// WhatsApp's language detection). The redirect page has <html lang="en"> and
// fires the native whatsapp:// (iOS) / intent:// (Android) deep link, jumping
// straight into the WhatsApp app where the locale is controlled by the phone
// OS, not the WebView.
export const waLink = (text = "Hi Execora! I want to order something.") => {
  const phone = CONTACT.whatsappNumber.replace(/[^0-9]/g, "");
  return `/wa.html?phone=${phone}&text=${encodeURIComponent(text)}`;
};

export const telLink = () =>
  `tel:${CONTACT.callNumber.replace(/[^0-9+]/g, "")}`;

export const USE_CASES = [
  {
    id: "flowers",
    title: "Flowers",
    description:
      "Orchids, sunflowers or anything you need from a nearby florist — we’ll pick it up and deliver.",
    image: flowersImg,
  },
  {
    id: "mango-juice",
    title: "Mango Juice",
    description:
      "Fresh mango juice from a local shop — sourced and delivered to your doorstep.",
    image: mangoJuiceImg,
  },
  {
    id: "electrical",
    title: "Electrical Items",
    description:
      "Need a tube light, wires or small electrical items? We’ll get them from a nearby store.",
    image: electricalImg,
  },
  {
    id: "watch-battery",
    title: "Watch Battery Replacement",
    description:
      "We’ll get your watch battery replaced at a nearby shop and return it to you.",
    image: watchImg,
  },
  {
    id: "photocopy",
    title: "Photocopy Service",
    description:
      "Share your file, we’ll get it printed from a nearby shop and deliver it.",
    image: photocopyImg,
  },
  {
    id: "ironing",
    title: "Ironing Clothes",
    description:
      "Pickup and drop for ironing from a local dhobi — simple and convenient.",
    image: ironingImg,
  },
];

export const HERO_IMAGE = heroImg;

export const MAP_IMAGE = mapImg;
